import { DrawerItem } from "@gisce/oficina-virtual-components"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router";
import {
  Person,
  PersonAdd,
  Message,
} from "@mui/icons-material";
import ContractationListItems from "../../CustomItems/ContractationListItems";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";

export const GroupedSideBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const Settings = useSettingsContext();

  return <>
    {<DrawerItem
      icon={<Person />}
      label={t('common:text.login_title')}
      onClick={() => navigate(t('common:url.login'))}
      selected={location.pathname === t('common:url.login')}
    />}
    {Settings.features?.signup && <DrawerItem
      icon={<PersonAdd />}
      label={t('common:text.login_view_button_activate')}
      onClick={() => navigate(t('common:url.activate'))}
      selected={location.pathname === t('common:url.activate')}
    />}
    {Settings.features?.unsignedContact && 
      Settings.features?.contact && <DrawerItem
      icon={<Message />}
      label={t('common:text.contact_title')}
      onClick={() => navigate(t('common:url.unsigned_contact'))}
      selected={location.pathname === t('common:url.unsigned_contact')}
    />}
  </>
}
